import { render } from "./renewal-service-drawer.vue?vue&type=template&id=d0ef04b4&ts=true"
import script from "./renewal-service-drawer.vue?vue&type=script&lang=ts"
export * from "./renewal-service-drawer.vue?vue&type=script&lang=ts"

import "./renewal-service-drawer.vue?vue&type=style&index=0&id=d0ef04b4&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__